import { Component, OnInit } from '@angular/core';
//import { CommonService } from 'src/app/_services/common.service';

import { CommonService } from './../../_services/common.service';
import {MatSnackBar} from '@angular/material';

import { FormsModule } from '@angular/forms';
import {INgxMyDpOptions, IMyDateModel} from 'ngx-mydatepicker';


@Component({
  selector: 'app-planmaster',
  templateUrl: './planmaster.component.html',
  styleUrls: ['./planmaster.component.css']
})
export class PlanmasterComponent implements OnInit {

myOptions: INgxMyDpOptions = {
    // other options...
    dateFormat: 'dd-mm-yyyy',
};

productLoading:Boolean=false
  array = [];
  sum = 10;
  page=0;
  planlist:any;
  totalRecords:any = 0;
  size = 10;
  startdate="";
  enddate="";
planfilter: any = {
  planname:"",
  planstartdate:"",
  planenddate:"",
  plantype:"",
  status:"Active"
};

constructor(private commonService:CommonService,private snackbar:MatSnackBar) 
{

}

ngOnInit() 
{
this.getplanlist(1,this.planfilter);
}

getplanlist(page: number,planfilter){

  this.productLoading=true

  this.commonService.getPlanlist((page - 1) ,this.size,planfilter).subscribe((response) => {
    if(response.status_code == 200){
      this.productLoading=false
      this.planlist=response.Data
      this.totalRecords = response.total_count
      this.page=page
    }else{
      this.planlist = [];
      this.totalRecords = 0 ;
      this.productLoading=false
 this.snackbar.open(response.Metadata.Message, '', {
  duration: 2000,
   verticalPosition:"top",
  extraClasses: ['bg-red']
}); 
    }
  },
  (err: any) => console.log("error",err),() =>
    console.log("getCustomersPage() retrieved customers for page:", + page)
  );

}

pageChanged(event)
{
this.getplanlist(event,this.planfilter)
}

onStartDateChanged(event: IMyDateModel): void 
{
if(event.formatted !== '') {
this.startdate=event.formatted
}
}
  
onEndDateChanged(event: IMyDateModel):void
{
if(event.formatted !== '') 
{
this.enddate=event.formatted
}
}
  



onSubmit() 
{
this.planfilter.planstartdate=this.startdate
this.planfilter.planenddate=this.enddate
this.getplanlist(1,this.planfilter)
}

clearfilter()
{
  this.planfilter.planname=""
  this.planfilter.planstartdate=""
  this.planfilter.planenddate=""
  this.planfilter.plantype=""
  this.planfilter.status=""
//console.log("clearfilter","clearfilter call")
this.getplanlist(1,this.planfilter)
}



statuschange(planid,status)
{
this.commonService.updatestatus(planid,status)
.subscribe(
data => {
console.log("data",data);
if(data.status_code==200)
{
console.log("data",data)  
}
else
{
console.log("data",data)  
}
})
}


}



// WEBPACK FOOTER //
// ./src/app/component/planmaster/planmaster.component.ts